module.exports = __webpack_public_path__ + "media/images/flags/CK-b5834084e938402b1d3eb5cc3875d30c.svg";